module.exports = "<p>\n  base works!\n</p>\n"